// extracted by mini-css-extract-plugin
export default {"containerx":"Home_containerx__Z0PxN","containeClose":"Home_containeClose__JgLvn","containertext":"Home_containertext__CzqHk"};